// Adapted from davinci-elections apps/web/src/theme/recipes/menu.ts @ 6e23f58
import { menuAnatomy } from '@chakra-ui/react/anatomy'
import { defineSlotRecipe } from '@chakra-ui/react'

/**
 * A menu is a floating panel (R113): `bg.panel` with a border and the raised shadow, so it stands off the page. The
 * entry under the pointer or the keyboard gets the hover fill; the selected entry the accent tint and label.
 */
const baseStyle = {
  content: {
    p: 1,
    borderRadius: 'md',
    borderWidth: '1px',
    borderColor: 'border',
    boxShadow: 'raised',
    bg: 'bg.panel',
  },
  item: {
    borderRadius: 'sm',
    color: 'fg',
    _highlighted: {
      bg: 'bg.muted',
    },
    _selected: {
      bg: 'brand.subtle',
      color: 'brand.fg',
    },
    _checked: {
      bg: 'brand.subtle',
      color: 'brand.fg',
    },
  },
  itemGroupLabel: {
    color: 'fg.muted',
  },
  separator: {
    m: 0,
    my: 1,
    borderColor: 'border',
  },
}

export const Menu = defineSlotRecipe({
  slots: menuAnatomy.keys(),
  base: baseStyle,
})
